import { HStack } from '@bpba/ui-components';
import styled from 'styled-components';

type AceptacionTyCProps = {
  aceptaTyc: (aceptaTyC: boolean) => void;
  estadoTycs: boolean | null;
};

export const AceptacionTyC = ({ aceptaTyc, estadoTycs }: AceptacionTyCProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    aceptaTyc(event.target.checked);
  };

  return (
    <HStack justifyContent={'space-evenly'} color="primary.0" my={'12px'}>
      <StyledCheckbox type="checkbox" onChange={handleChange} checked={estadoTycs!} aria-labelledby="terms-label" />
      <StyledLink id="terms-label" href="https://www.bancoprovincia.com.ar/CDN/Get/bases_y_condiciones_mesumo" target="_blank">
        Aceptá los nuevos términos y condiciones para continuar
      </StyledLink>
    </HStack>
  );
};

const StyledCheckbox = styled.input({
  appearance: 'auto',
  width: '20px',
  height: '20px',
  marginRight: '8px',
});

const StyledLink = styled.a({
  textAlign: 'center',
});
